import * as React from 'react'
import { ButtonToggle } from '../../../Toggles/ButtonToggle'
import { ButtonToggleList } from '../../../Toggles/ButtonToggleList/container'

interface ResultsFiltersProps {
  filterToggles: ButtonToggle[]
  headerText: string
  onFilterToggle: (toggle: ButtonToggle) => void
  visible: boolean
}

export const ResultsFilters: React.SFC<ResultsFiltersProps> = (props) => {
  const { filterToggles, headerText, onFilterToggle, visible } = props

  if (visible) {
    return <ButtonToggleList title={headerText} toggleBadge={onFilterToggle} badges={filterToggles} />
  }
  return null
}
